import ProfilePage from '../../../components/profile/ProfilePage';

const ProfileSettingsPage = () => {
    return (
        <div className='p-4'>
            <ProfilePage />
        </div>
    );
};

export default ProfileSettingsPage;